import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getRouteGateConfig, userCanAccessPath } from "../lib/permissions";
import { useAuthStore } from "../stores/authStore";
import { ModulePageGate } from "./access/AccessGate";
import NoAccess from "./NoAccess";
import Spinner from "./Spinner";

export default function PermissionRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const isLoading = useAuthStore((s) => s.isLoading);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const profilePending = isLoading || (isAuthenticated && !user);

  if (profilePending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!userCanAccessPath(user, pathname)) {
    const gate = getRouteGateConfig(pathname);
    if (gate) {
      return (
        <ModulePageGate
          gateId={gate.gateId}
          placeholder={gate.placeholder}
          title={t(gate.titleI18nKey)}
        >
          {children}
        </ModulePageGate>
      );
    }
    return <NoAccess />;
  }

  return <>{children}</>;
}
